import { render, staticRenderFns } from "./SnowDataTableField.vue?vue&type=template&id=4753a2d6&scoped=true&"
import script from "./SnowDataTableField.vue?vue&type=script&lang=js&"
export * from "./SnowDataTableField.vue?vue&type=script&lang=js&"
import style0 from "./SnowDataTableField.vue?vue&type=style&index=0&id=4753a2d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4753a2d6",
  null
  
)

export default component.exports